import branding from "./branding.json";
import logoPng from "./logo.png";

// Single source of truth for the app logo - every consumer imports from
// here instead of reaching into the asset file directly with its own
// relative path, so changing the file (or swapping it for a different
// logo entirely) only ever means editing this one line.
export const logoUrl = logoPng;

// `Logo` predates the switch from an inline SVG (sized by its own
// width/height attributes) to this raster mark - kept as a component
// wrapping <img> rather than switched to a plain export so the existing
// `<SimplifySMLogo />` call sites (auth/onboarding brand marks) don't need
// their own width/height, same as the SVG they replaced.
export const Logo = (props) => (
  <img src={logoPng} alt={branding.appName} width={24} height={24} {...props} />
);

// Single source of truth for brand name/links/colors - same idea as the
// logo above. JS/JSX consumers import these instead of hardcoding
// "Kribana"/hex values, so a future rebrand only means editing branding.json.
// SCSS can't import JSON in this CRA setup (not ejected, no CRACO), so
// scripts/generateDesignTokens.js regenerates src/_styles/abstracts/*.scss
// from `tokens` below on every start/build - no manual syncing needed.
export const APP_NAME = branding.appName;
export const BRAND_LINKS = branding.links;
export const BRAND_COLORS = branding.tokens.colors;
export const SUPPORT_EMAIL = branding.supportEmail;
export const BRAND_TOKENS = branding.tokens;
